export enum Columns {
  Batchname = 'batchName',
  Alias = 'alias',
  ModelNumber = 'modelNumber',
  SerialNo = 'serialNo',
  MacAddress = 'macAddress',
  DateAdded = 'dateAdded',
  CustomerName = 'customerName',
  Status = 'status',
  Selection = 'selection',
}

export type FilterKeys =
  | Columns.Batchname
  | Columns.ModelNumber
  | Columns.CustomerName
  | Columns.Status;

export const FilterKeys = [
  Columns.Batchname,
  Columns.ModelNumber,
  Columns.CustomerName,
  Columns.Status,
] as const;

export type FilterOption = {
  column: FilterKeys;
  label: string;
  value: string;
};

export type FilterOptions = {
  [key in FilterKeys]: { all: FilterOption[]; enabled: FilterOption[] };
};
